import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentAgreementPage, { getDefaultPageData } from "components/EDEStatements/pages/EDEStatementsEnrollmentAgreementPage";

/**
 * @name CaptureMabiEDEStatementsEnrollmentVerificationCodeEntered
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentVerificationCodeEntered(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "confirmationCode", "value" ], "BHM47")
    .submit();

    return <EDEStatementsEnrollmentAgreementPage data={ data } />;
}